export const FETCH_GET_COMPLETED_TASK_REPORTS_REQUEST = 'FETCH_GET_COMPLETED_TASK_REPORTS_REQUEST'
export const FETCH_GET_COMPLETED_TASK_REPORTS_SUCCESS = 'FETCH_GET_COMPLETED_TASK_REPORTS_SUCCESS'
export const FETCH_GET_COMPLETED_TASK_REPORTS_FALUIRE = 'FETCH_GET_COMPLETED_TASK_REPORTS_FALUIRE'
export const SEARCH_COMPLETED_REPORT='SEARCH_COMPLETED_REPORT'